module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": _vm.errorImg,
      "alt": "error"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "err-msg"
  }, [_c('h3', {
    staticClass: "err-title"
  }, [_vm._v(_vm._s(_vm.title) + "!")]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, [_c('a', {
    attrs: {
      "href": _vm.config.adminHost + 'login'
    }
  }, [_c('span', [_c('i', {
    staticClass: "iconfont icon-refresh"
  }), _c('a', {
    attrs: {
      "href": _vm.config.adminHost + 'leemmaCustomer'
    }
  }, [_vm._v("重新登陆")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "err-body"
  }, [_c('p', [_vm._v("可能原因")]), _vm._v(" "), _c('div', [_c('ul', [_c('li', [_vm._v("网络信号弱")]), _vm._v(" "), _c('li', [_vm._v("权限不足")]), _vm._v(" "), _c('li', [_vm._v("网站维护")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c67f188"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/error.vue
// module id = 929
// module chunks = 1